/**
 * Brand / vendor constants shared by the public site and the dashboard.
 *
 * OVACS is developed by Stirringapps. The "Developed by" credit
 * (components/common/DevelopedBy.jsx) links to STIRRINGAPPS_URL in a new tab.
 */
export const STIRRINGAPPS_NAME = 'Stirringapps'
export const STIRRINGAPPS_URL = 'https://stirringapps.com'

/**
 * The legal entity that operates OVACS, exactly as on the trade licence
 * (Sharjah Publishing City Free Zone). Stripe checks that the website matches
 * the licence, so these are code-owned and not editable from the Landing CMS.
 */
export const COMPANY = {
  legalName: 'Stirring Apps FZE LLC',
  legalNameAr: 'ستيرينغ أبس م م ح ذ م م',
  licenceNo: '4432662.01',
  address: 'Business Centre, Sharjah Publishing City Free Zone, Sharjah, United Arab Emirates',
  addressAr: 'مركز الأعمال، مدينة الشارقة للنشر - المنطقة الحرة، الشارقة، الإمارات العربية المتحدة',
}

export const OVACS_SUPPORT = {
  email: 'info@ovacs.com',
  phone: '+971 54 235 8420',
  whatsappLink: 'https://wa.me/971542358420',
}

// Footer "Legal" links — the same set on the landing page and the legal pages.
export const LEGAL_LINKS = [
  { href: '/pricing', en: 'Pricing', ar: 'الأسعار' },
  { href: '/terms', en: 'Terms & Conditions', ar: 'الشروط والأحكام' },
  { href: '/privacy', en: 'Privacy Policy', ar: 'سياسة الخصوصية' },
  { href: '/refund-policy', en: 'Refund Policy', ar: 'سياسة الاسترداد' },
  { href: '/contact', en: 'Contact', ar: 'اتصل بنا' },
]
